import { useSelector as _useSelector, TypedUseSelectorHook } from "react-redux";

import { GlobalState } from "types/globalState";

export const useSelector: TypedUseSelectorHook<GlobalState> = _useSelector;
